import { Directive } from '@angular/core';
import { ModuleService } from '@shared/services/module.service';

@Directive()
export class ModuleDirective {
    constructor(private moduleService: ModuleService) {}

    get isOrganisationModuleActive(): boolean {
        return this.moduleService.isOrganisationModuleActive;
    }

    get isReportModuleActive(): boolean {
        return this.moduleService.isReportModuleActive;
    }

    get isReportTemplateModuleActive(): boolean {
        return this.moduleService.isReportTemplateModuleActive;
    }

    get isSummaryReportModuleActive(): boolean {
        return this.moduleService.isSummaryReportModuleActive;
    }

    get isGlossaryModuleActive(): boolean {
        return this.moduleService.isGlossaryModuleActive;
    }

    get isHyperlinksModuleActive(): boolean {
        return this.moduleService.isHyperlinksModuleActive;
    }

    get isLanguageSelectionAvailable(): boolean {
        return this.moduleService.isLanguageSelectionAvailable;
    }

    get mainToolLanguage(): string {
        return this.moduleService.projectConfiguration.availableLanguages[0];
    }

    get isGermanEnabled(): boolean {
        return this.hasLanguage('de');
    }

    get availableLanguages(): string[] {
        return this.moduleService.projectConfiguration.availableLanguages;
    }

    hasLanguage(code: string): boolean {
        return this.moduleService.projectConfiguration.availableLanguages.includes(code);
    }

    get isCascadedReportingActive(): boolean {
        return this.moduleService.isCascadedReportingActive;
    }

    get isFaqModuleActive(): boolean {
        return this.moduleService.isFaqModuleActive;
    }

    get isMailingActive(): boolean {
        return this.moduleService.isMailingActive;
    }
}
